import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Modal, Ratio} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import getPlanLogo from '../../assets/img/getplan-logo.png';
import { showCoachmark, hideCoachmark } from './Coachmark';
import { VIDEO_EMBED_URL } from 'config';

const AUTOPLAY_VIDEO_URL = `${VIDEO_EMBED_URL}?autoplay=1&mute=1&rel=0`;

const WelcomeModal = ({ show, onHide }) => {
  const { t } = useTranslation();

  const handleSkip = () => {
    localStorage.setItem('hasWatchedTutorial', 'true');
    window.dispatchEvent(new Event('onboarding:tutorialWatched'));
    onHide();

    const userId = localStorage.getItem('UserId');
    if (userId) {
      axios.patch(
        `${process.env.REACT_APP_API_URL}/userRoute/updateTutorialWatchedStatus/${userId}`,
        {},
        { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
      ).catch((err) => console.warn('[onboarding] Failed to persist tutorial status:', err));
    }
    setTimeout(() => {
      const retakeBtn = document.querySelector('[data-tour="tour-retake"]');
      if (retakeBtn) {
        const dismissHatCoachmark = () => {
          hideCoachmark();
          retakeBtn.removeEventListener('click', dismissHatCoachmark);
        };

        retakeBtn.addEventListener('click', dismissHatCoachmark, { once: true });

        showCoachmark(
          retakeBtn,
          t('onboardingTour.retake.title', 'Onboarding Guide'),
          t(
            'onboardingTour.retake.description',
            'Access your tutorial video, guided tour, and workspace setup steps here anytime.'
          ),
          t('cm_gotIt', 'Got it'),
          dismissHatCoachmark
        );
      }
    }, 350);
  };

  return (
    <Modal
      show={show}
      onHide={handleSkip}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="modal-dialog-centered"
      contentClassName="border-0 rounded-4 shadow-lg overflow-hidden position-relative"
    >

      <button
        type="button"
        className="btn-close font-size-11 position-absolute top-0 end-0 m-3 z-1"
        onClick={handleSkip}
        aria-label={t('close', 'Close')}
      />

      <Modal.Body className="p-3 p-sm-4 text-center">
        <div className="d-flex justify-content-center align-items-center mb-2">
          <img
            src={getPlanLogo}
            alt="GetPlan"
            className="logo-img"
          />
        </div>

        <h4 className="mb-1 text-900 fw-bold">
          {t('onboardingTour.welcomeTitle', 'Welcome to GetPlan')}
        </h4>
        <p className="text-secondary fw-normal font-size-13 mb-2">
          {t(
            'onboardingTour.welcomeSubtitle',
            'Let’s get you familiar with GetPlan and get your workspace ready.'
          )}
        </p>

        <div className="mt-2">
          <Ratio aspectRatio="16x9" className="rounded-3 overflow-hidden bg-black shadow-sm">
            <iframe
              src={AUTOPLAY_VIDEO_URL}
              title={t('onboardingTour.videoTitle', 'GetPlan Tutorial')}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Ratio>
        </div>
      </Modal.Body>
    </Modal>
  );
};

WelcomeModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
};

export default WelcomeModal;